export type UserProfileTabName =
  | 'patient'
  | 'billing'
  // | 'assessment' // to be removed with v2
  | 'insurance'
  | 'plans'
  | 'pregnancy'
  | 'pregnancies'
  | 'payments'
  | 'auth' // to be removed with v2
  | 'claims'
  | 'files'
  // | 'visits'
  | 'labs'
  | 'consent-forms'
  | 'gyn'

export type V1ProfileTabName =
  | 'patient'
  // | 'assessment'
  | 'pregnancy'
  | 'payments'
  | 'auth'
  | 'claims'
  | 'files'
  // | 'visits'
  | 'consent-forms'

export type PatientTabName = 'consent-forms' // | 'visits'
export type PregnancyTabName =
  | 'assessment'
  | 'sign-on'
  | 'authorizations'
  | 'payments'
  | 'insurance'
  | 'questionnaire'
  | 'charting'
  | 'labs'
export type SubTabName = PatientTabName | PregnancyTabName
export type PregnancyTab = SubTab<PregnancyTabName>
export type GynTabName = 'profile' | 'visits' | 'exams'

export interface SubTab<Path extends string = string> {
  path: Path
  name: string
}
// export type SubTabGroup = Omit<SubTab, 'component'> & { children: SubTab[] }
export type SubTabGroup<
  Path extends string = string,
  SubPath extends string = string,
> = SubTab<Path> & { children: SubTab<SubPath>[] }
export const isSubTabGroup = (tab: SubTab | SubTabGroup): tab is SubTabGroup =>
  (tab as SubTabGroup).children !== undefined

export type Tabs = Array<SubTab | SubTabGroup>

export type ProfileTab = SubTab<UserProfileTabName>
export type ProfileTabGroup<SubPath extends string = string> = SubTabGroup<
  UserProfileTabName,
  SubPath
>
